import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const BusinessesTableHeaders = [
  {
    title: 'ID',
    align: 'start',
    key: 'id',
  },
  {
    title: 'Name',
    align: 'start',
    key: 'name',
  },
  {
    title: 'Actions',
    align: 'end',
    key: 'actions',
    sortable: false,
  },
] as const satisfies readonly TableHeaderSpec[]
